import {
    changeFormStatus,
    clientFormReview,
    createForm,
    deleteForms,
    editForm,
    getClientFiledForm,
    getClientInviteForm,
    getFormById,
    getFormDefault,
    getForms,
    getFormSettings,
    requestInviteForm,
    resendInviteForm,
    resetFormById,
    resetFormDefault,
    resetForms,
    saveInviteForm,
} from './form.action';

export { formReducer } from './form.reducer';
export { watchForm } from './form.saga';

export const formActions = {
    getForms,
    resetForms,
    // getBasicForms,
    getFormDefault,
    resetFormDefault,
    getFormById,
    resetFormById,
    getFormSettings,
    createForm,
    editForm,
    deleteForms,
    changeFormStatus,
    getClientInviteForm,
    saveInviteForm,
    resendInviteForm,
    requestInviteForm,
    getClientFiledForm,
    clientFormReview,
};
